<section [fxLayout]="displayMode() === 'default' ? 'row' : 'column'" fxLayoutGap="20px" fxLayoutAlign="start stretch">
  <div [fxFlex]="displayMode() === 'default' ? '60%' : '100%'" fxLayout="row" [fxLayoutAlign]="'start start'" fxLayoutGap="16px">
    <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="8px" fxFlex="1 1 auto">
      <span (click)="selectAsset.emit(asset())" class="mve-detail-popup-title fw-600 mve-detail-popup-title-clickable">{{ asset().name }}</span>
      <iot4bos-ui-asset-status-chip data-cy="asset-info-status" [asset]="asset()" />
    </div>

    <div fxFlex="0 0 auto" fxLayoutAlign="end start">
      <ng-content select="[headerAction]" />
    </div>
  </div>

  <div [fxFlex]="displayMode() === 'default' ? '40%' : '100%'" fxLayout="column">
    @if (asset().optionalProperties.equipmentId) {
      <iot-platform-ui-detail-popup-display-property property="{{ 'ASSETS.CARD.EQUIPMENT_ID' | translate }}:" value="{{ asset().equipmentId | infoDisplay }}" />
    }
    @if (asset().optionalProperties.shipTo) {
      <iot-platform-ui-detail-popup-display-property
        property="{{ 'IOT_DICTIONARY.SHIPTO' | translate }}:"
        value="{{ $safeNavigationMigration(asset().dispatch?.shipTo) | infoDisplay }}"
      />
    }
    @if (asset().optionalProperties.product1) {
      <iot-platform-ui-detail-popup-display-property
        property="{{ 'ASSETS.CARD.PRODUCT_1' | translate }}:"
        value="{{ !!asset().product1 ? asset().product1.identifier + ':' + asset().product1.name : '-' }}"
      />
    }
    @if (asset().optionalProperties.product2) {
      <iot-platform-ui-detail-popup-display-property
        property="{{ 'ASSETS.CARD.PRODUCT_2' | translate }}:"
        value="{{ !!asset().product2 ? asset().product2.identifier + ':' + asset().product2.name : '-' }}"
      />
    }
  </div>
</section>
